import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-leistungen',
  templateUrl: './leistungen.component.html',
  styleUrls: ['./leistungen.component.scss']
})
export class LeistungenComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
